<script>
// Gauge da nota geral da avaliação: anel (TranscriptRingGauge genérico) com o
// número no centro + rótulo do tier (ex.: "Crítico") com ponto colorido abaixo.
import TranscriptRingGauge from '@modules/crm/components/transcript-ring-gauge/transcript-ring-gauge.vue'
import {
  scoreColor,
  scoreColorSoft,
  scoreTier,
  formatScore,
  toScore,
} from '@modules/crm/utils/transcriptScore'

const MAX_SCORE = 10

export default {
  name: 'TranscriptScoreGauge',
  components: { TranscriptRingGauge },
  props: {
    score: { type: [Number, String], default: null },
    size: { type: Number, default: 96 },
  },
  computed: {
    scoreValue() {
      return toScore(this.score)
    },
    hasScore() {
      return this.scoreValue !== null
    },
    formatted() {
      return formatScore(this.score)
    },
    color() {
      return scoreColor(this.score)
    },
    track() {
      return scoreColorSoft(this.score)
    },
    tier() {
      return scoreTier(this.score)
    },
    max() {
      return MAX_SCORE
    },
    valueStyle() {
      return { fontSize: Math.round(this.size * 0.3) + 'px', color: this.color }
    },
  },
}
</script>

<template>
  <div class="d-flex flex-column align-center transcript-score-gauge">
    <TranscriptRingGauge
      :value="scoreValue"
      :max="max"
      :color="color"
      :track-color="track"
      :size="size"
    >
      <span class="font-semibold transcript-score-gauge__value" :style="valueStyle">
        {{ formatted }}
      </span>
    </TranscriptRingGauge>

    <span v-if="hasScore" class="d-inline-flex align-center mt-3">
      <span
        class="transcript-score-gauge__dot mr-2"
        :style="{ background: tier.color }"
      ></span>
      <span class="az-text-primary az-size-12 font-semibold">{{ tier.label }}</span>
    </span>
  </div>
</template>

<style lang="sass" scoped>
.transcript-score-gauge
  &__value
    line-height: 1

  &__dot
    width: 8px
    height: 8px
    border-radius: 99999px
</style>
